import 'react-medium-image-zoom/dist/styles.css';

import ProductVideo from '@common/components/ProductVideo';
import ZoomLens from '@common/components/ZoomLens';
import { getYoutubeVideoThumbnail, isMobile, matchYoutubeUrlRegex } from '@common/utils';
import { getLambdaLink } from '@common/utils';
// import VerticalGallery from '@common/components/VerticalGallery';
import Arrow from '@images/GalleryArrow.svg';
import { PlayButtonIcon } from '@instamojo/icons';
// import { ReactComponent as Caret } from '@common/icons/Caret.svg';
import Carousel from '@lib/Carousel';
// import Carousel from '@brainhubeu/react-carousel';
// import { ReactComponent as CarouselArrowRight } from '@common/icons/CarouselArrowRight.svg';
import Image from '@lib/Image';
import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

export interface GalleryProps {
  className?: string;
  isZoomEnabled: boolean;
  images: string[];
  quickView?: boolean;
  inStock?: boolean;
  imageDescription?: string;
  productVideoUrl?: string;
  productVideoEnabled?: boolean;
}
// interface GalleryListProps {
//   images: Array<string>;
//   setSelectedImage: React.Dispatch<React.SetStateAction<string>>;
//   selectedImage: string;
// }

const Gallery: React.FunctionComponent<GalleryProps> = ({
  // isZoomEnabled = false,
  quickView,
  inStock,
  images = [],
  imageDescription = '',
  productVideoUrl,
  productVideoEnabled,
}) => {
  const [selectedImage, setSelectedImage] = useState(images[0] || '');
  const [selectedVideo, setSelectedVideo] = useState('');
  const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');
  const [mouseEnter, setMouseEnter] = useState(false);
  const [lensPos, setLensPos] = useState({ left: 0, top: 0 });
  useEffect(() => {
    setSelectedImage(images[0]);
  }, [images]);
  const handleMouseMove = (e) => {
    const { left, top, width, height } = imageRef.current.getBoundingClientRect();
    const minX = Math.min(e.pageX - left, width - 100);
    const minY = Math.min(e.pageY - top, height - 100);
    setLensPos({
      left: minX,
      top: minY,
    });
    setBackgroundPosition(`-${minX * 4}px -${minY * 4}px`);
  };
  const imageRef = useRef(null);
  const zoomedImage = selectedImage.replace(/(.*)(_image\d*_)(.*)/, '$1$2zoom_$3');
  const imagesGallery = [...images];
  if (productVideoEnabled) {
    imagesGallery.push(productVideoUrl);
  }
  return (
    <div
      className={classnames(' w-full h-full flex flex-col sm:flex-row md:flex-row', {
        'mt-16': quickView,
      })}
    >
      <div
        className={classnames('hidden sm:flex md:flex', {
          'sm:h-432 md:h-628': quickView,
          'sm:h-432 md:h-568': !quickView,
        })}
      >
        {VerticalGallery(
          imagesGallery,
          selectedImage,
          setSelectedImage,
          quickView,
          imageDescription,
          productVideoUrl,
          setSelectedVideo,
          getYoutubeVideoThumbnail,
          selectedVideo,
        )}
      </div>
      <div
        className={classnames('flex flex-wrap', {
          'sm:ml-16 md:ml-16': !quickView,
        })}
      >
        <div
          className={classnames('relative overflow-visible text-center flex  justify-center', {
            'w-full h-432 md:w-522 md:h-568': !quickView,
            'w-full md:w-502 md:h-568': quickView,
          })}
        >
          {selectedVideo ? (
            <ProductVideo
              productVideoUrl={selectedVideo}
              height={isMobile() && quickView ? '432' : isMobile() ? '432' : quickView ? '522' : '568'}
              width={isMobile() && quickView ? '320' : isMobile() ? '320' : quickView ? '502' : '522'}
            />
          ) : (
            <div>
              <figure
                onMouseEnter={() => {
                  setMouseEnter(true);
                }}
                onMouseLeave={() => {
                  setMouseEnter(false);
                }}
                onMouseMove={handleMouseMove}
                className="w-full h-full"
              >
                <img
                  ref={imageRef}
                  className={classnames('object-contain rounded border border-disabled', {
                    'min-w-full min-h-432 md:min-w-522 md:min-h-568 max-w-full max-h-432 w-374 md:w-522 md:max-w-522 md:max-h-568': !quickView,
                    'min-w-full min-h-432 md:min-w-502 md:min-h-628 max-w-full max-h-432 w-374 md:w-502 md:max-w-502 md:max-h-628': quickView,
                  })}
                  loading={'lazy'}
                  src={getLambdaLink({
                    link: selectedImage,
                    width: 0,
                    height: 0,
                  })}
                  alt={imageDescription}
                />
                {!inStock && (
                  <div
                    className={classnames(
                      'absolute flex flex-wrap justify-center rounded content-center top-0 bg-black bg-opacity-35',
                      {
                        'min-w-full min-h-432 md:min-w-522 md:min-h-568 max-w-full max-h-432 w-374 md:w-522 md:max-w-522 md:max-h-568': !quickView,
                        'min-w-full min-h-432 md:min-w-502 md:min-h-628 max-w-full max-h-432 w-374 md:w-502 md:max-w-502 md:max-h-628': quickView,
                      },
                    )}
                  >
                    <button
                      className="relative uppercase bg-white  h-40 md:h-48 w-150 md:w-158 text-black rounded text-14 md:text-16 tracking-14 md:tracking-16 font-bold"
                      font-customisation="para-text"
                    >
                      out of stock
                    </button>
                  </div>
                )}
                {!isMobile() && !quickView ? <ZoomLens lensPos={lensPos} mouseEnter={mouseEnter} /> : null}
              </figure>

              {mouseEnter && !quickView && (
                <div
                  className="hidden md:block absolute rounded-sm z-10 overflow-hidden"
                  style={{
                    left: 540,
                    top: 0,
                    // height: Math.min(imageRef.current?.naturalHeight || 500, 500),
                    // width: Math.min(imageRef.current?.naturalWidth || 500, 500),
                    height: 400,
                    width: 400,
                    backgroundImage: `url('${zoomedImage}'), url('${selectedImage}')`,
                    backgroundPosition,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: `${imageRef.current?.width * 4 || 500}px ${imageRef.current?.height * 4 || 500}px`,
                  }}
                ></div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="container px-0 sm:hidden md:hidden">
        <div className="flex flex-row flex-no-wrap mt-20 overflow-x-scroll ">
          {imagesGallery.map((image, index) => (
            <div key={index} className="flex">
              {matchYoutubeUrlRegex(image) ? (
                <div
                  className="relative h-84 min-w-84 max-w-84"
                  onClick={() => {
                    setSelectedImage('');
                    setSelectedVideo(productVideoUrl);
                  }}
                >
                  <div className="absolute rounded mr-6 h-84 min-w-84 max-w-84 zIndex-999 bg-gray opacity-70 flex items-center justify-center">
                    <PlayButtonIcon size="24" color="#000" />
                  </div>
                  <Image
                    src={getYoutubeVideoThumbnail(productVideoUrl)}
                    alt={imageDescription}
                    className={classnames('object-contain rounded mr-6 h-84 min-w-84 max-w-84', {
                      'border-black border-2 shadow-gallerHighlight': selectedVideo === productVideoUrl,
                      'border-gallery-normal border': selectedVideo !== productVideoUrl,
                    })}
                    noDefaultDimensions
                    noDefaultFit
                  />
                </div>
              ) : (
                <Image
                  src={getLambdaLink({
                    link: image,
                    width: 0,
                    height: 0,
                  })}
                  alt={imageDescription}
                  className={classnames('object-contain rounded mr-6 h-84 min-w-84 max-w-84', {
                    'border-black border-2 shadow-gallerHighlight': selectedImage === image,
                    'border-gallery-normal border': selectedImage !== image,
                  })}
                  key={image}
                  onClick={() => {
                    setSelectedImage(image);
                    setSelectedVideo('');
                  }}
                  noDefaultDimensions
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const VerticalGallery = (
  images,
  selectedImage,
  setSelectedImage,
  quickView,
  imageDescription,
  productVideoUrl,
  setSelectedVideo,
  getYoutubeVideoThumbnail,
  selectedVideo,
) => {
  return (
    <div className="cursor-pointer sm:h-full md:h-full">
      {/* {images.length > 1 && ( */}
      <Carousel
        isVertical
        items={images}
        renderSlide={({ chunkedItem, chunkBy }) => {
          const images = chunkedItem as string[];
          return (
            <div className={'flex flex-col justify-center'}>
              {images.map((image) => (
                <>
                  {matchYoutubeUrlRegex(image) ? (
                    <div
                      className={classnames('relative h-84 min-w-84 w-84', {
                        'mx-16': quickView,
                      })}
                      onClick={() => {
                        setSelectedImage('');
                        setSelectedVideo(productVideoUrl);
                      }}
                    >
                      <div className="absolute h-84 min-w-84 w-84 rounded-5 zIndex-999 bg-gray opacity-70 flex items-center justify-center">
                        <PlayButtonIcon size="24" color="#000" />
                      </div>
                      <Image
                        src={getYoutubeVideoThumbnail(productVideoUrl)}
                        alt={imageDescription}
                        className={classnames('object-contain rounded mb-13 h-84 min-w-84 w-84', {
                          'border-black border-2 shadow-gallerHighlight': selectedVideo === productVideoUrl,
                          'border-gallery-normal border': selectedVideo !== productVideoUrl,
                        })}
                        noDefaultDimensions
                        noDefaultFit
                      />
                    </div>
                  ) : (
                    <Image
                      src={getLambdaLink({
                        link: image,
                        width: 0,
                        height: 0,
                      })}
                      alt={imageDescription}
                      className={classnames('object-contain rounded mb-13 h-84 min-w-84 w-84', {
                        'border-black border-2 shadow-gallerHighlight': selectedImage === image,
                        'border-gallery-normal border': selectedImage !== image,
                        'mx-16': quickView,
                      })}
                      key={image}
                      onClick={() => {
                        setSelectedImage(image);
                        setSelectedVideo('');
                      }}
                      noDefaultDimensions
                    />
                  )}
                </>
              ))}
              {[...Array(chunkBy - images.length)].map((key) => (
                <div key={key} className="h-5 w-5" />
              ))}
            </div>
          );
        }}
        breakpoints={[{ width: 0, chunkBy: isMobile() ? 4 : 6 }]}
        renderControls={({ gotoPrevious, gotoNext, isFirstSlide, isLastSlide }) => {
          return (
            <div
              style={
                isMobile()
                  ? images.length < 4
                    ? { display: 'none' }
                    : null
                  : images.length < 6
                  ? { display: 'none' }
                  : null
              }
            >
              <div
                className="absolute left-0 top-0 w-full flex justify-center"
                style={isFirstSlide ? { opacity: 0.7 } : { opacity: 1 }}
              >
                <div className="focus:outline-none" onClick={() => (!isFirstSlide ? gotoPrevious() : null)}>
                  <div className="cursor-pointer w-50 h-36">
                    <Image
                      className={'object-cover rounded w-full h-full transform rotate-180'}
                      src={Arrow}
                      noDefaultDimensions
                      alt="Up"
                    />
                  </div>
                </div>
              </div>
              <div
                className="absolute left-0 bottom-0 w-full flex justify-center"
                style={isLastSlide ? { opacity: 0.7 } : { opacity: 1 }}
              >
                <div className="focus:outline-none" onClick={() => (!isLastSlide ? gotoNext() : null)}>
                  <div className="cursor-pointer w-50 h-36">
                    <Image
                      className={'object-cover rounded w-full h-full '}
                      src={Arrow}
                      noDefaultDimensions
                      alt="Down"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      />
      {/* )} */}
    </div>
  );
};
export default Gallery;
